import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';
import { forgotPassword } from '../api';
import { AuthCard } from '../components/AuthCard';

const GENERIC_MESSAGE = 'If an account uses that email, we sent it a link to reset the password. Check your inbox.';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    const value = email.trim();
    if (!value) {
      setError('Enter your email');
      return;
    }
    setSending(true);
    try {
      const res = await forgotPassword(value);
      setMessage(res.data?.message || GENERIC_MESSAGE);
    } catch (err) {
      setError(err.response?.data?.error || 'Could not send the link. Try again.');
    } finally {
      setSending(false);
    }
  };

  return (
    <AuthCard subtitle="Reset your password">
      {message ? (
        <>
          <div className="alert alert-success" role="status">{message}</div>
          <p className="login-text">The link works once and expires after a while. If nothing arrives, check your spam folder or ask your administrator.</p>
        </>
      ) : (
        <>
          <p className="login-text">Enter the email you sign in with and we will send you a link to choose a new password.</p>
          {error && <div className="alert alert-error" role="alert" aria-live="assertive">{error}</div>}
          <form onSubmit={handleSubmit} noValidate>
            <div className="form-group">
              <label className="form-label" htmlFor="forgot-email">Email</label>
              <input
                id="forgot-email"
                type="email"
                className="form-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                autoComplete="email"
                required
                aria-required="true"
              />
            </div>
            <button type="submit" className="btn btn-primary login-btn" disabled={sending}>
              {sending ? <span>Sending...</span> : (<><Mail size={18} /><span>Send reset link</span></>)}
            </button>
          </form>
        </>
      )}
      <p className="login-request"><Link to="/login">Back to sign in</Link></p>
    </AuthCard>
  );
}

export default ForgotPassword;
